module.exports = "https://static.wanderu.com/static/media/nl.8b5197ab.svg";